import React from "react";

const getTypeAccent = (type) => {
  switch (type) {
    case 'new_appointment':
    case 'new_patient_visit':       return '#198754';
    case 'appointment_rescheduled': return '#ffc107';
    case 'appointment_cancelled':
    case 'followup_missed':         return '#dc3545';
    case 'daily_schedule_reminder': return '#0d6efd';
    case 'weekly_summary':          return '#0dcaf0';
    case 'profile_incomplete':      return '#ffc107';
    default:                        return '#495057';
  }
};

const NotificationToast = ({ toasts, onDismiss, onNotificationClick }) => {
  if (!toasts || toasts.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        width: '320px',
      }}
    >
      {toasts.map((t) => (
        <div
          key={t.toastId}
          onClick={() => onNotificationClick(t)}
          className="shadow"
          style={{
            background: '#fff',
            borderRadius: '10px',
            borderLeft: `4px solid ${getTypeAccent(t.type)}`,
            padding: '12px 14px',
            cursor: 'pointer',
            animation: 'toast-slide-in 0.25s ease-out',
          }}
        >
          <div className="d-flex justify-content-between align-items-start">
            <small className="fw-bold" style={{ color: getTypeAccent(t.type) }}>
              {t.title}
            </small>
            <button
              className="btn-close"
              style={{ fontSize: '0.6rem' }}
              onClick={(e) => {
                e.stopPropagation();
                onDismiss(t.toastId);
              }}
            />
          </div>
          <small className="text-secondary d-block mt-1">{t.message}</small>
        </div>
      ))}

      <style>{`
        @keyframes toast-slide-in {
          from { transform: translateX(30px); opacity: 0; }
          to   { transform: translateX(0);     opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default NotificationToast;